import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tag from '../../../components/Tag'
import { RootState } from "../../../redux/store";
import { setSignupData } from '../../../redux/signup';
import EditTagsQuestion from "../../../components/EditTagsQuestion";
import { GAEventNames, GACategoryName, GAUniqueEventIds } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const LookingForQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 14));

    const onSave = (tags: number[]) => {
        register.memberLookingFor = tags;
        dispatch(setSignupData(register));
        props.next();

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 7", "אישור סוג היכרות", GAUniqueEventIds.APP_SIGNUP)

    }

    return (
        <>
            {
                question && question[0].tags

                    ?
                    <EditTagsQuestion
                        title={question[0].question}
                        subtitle={question[0].questionSubTitle}
                        buttonText={"אפשר להמשיך"}
                        tags={question[0].tags}
                        onSave={onSave}
                        questionMaxAsnwer={question[0].maxAnswer}
                        questionMinAsnwer={question[0].minAnswer}
                        selectedTagsValue={register.memberLookingFor}
                        showCanPickMoreThanOneText={false}
                        isMandatoryQuestion={true}
                    />
                    :
                    null

            }

        </>
    )
}

export default LookingForQuestion;